var React = require('react');

function BottomBlobRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M73.9469 0.1713C59.9101 1.7399 52.7999 17.3522 41.9806 26.4602C32.1909 34.7014 20.3218 40.014 13.6374 50.9413C5.50044 64.2431 -1.53682 79.1114 0.292114 94.6101C2.32631 111.848 9.74289 129.742 24.0825 139.456C38.275 149.07 57.1734 147.968 73.9469 144.505C88.4773 141.505 98.6228 129.987 110.84 121.544C123.481 112.809 143.427 109.352 146.616 94.2888C149.854 78.9935 131.736 68.083 125.159 53.9068C119.73 42.2042 120.434 28.0164 111.543 18.6866C101.653 8.3096 88.1696 -1.41808 73.9469 0.1713Z","fill":"#39A77E"}));
}

BottomBlobRight.defaultProps = {"width":"147","height":"147","viewBox":"0 0 147 147","fill":"none"};

module.exports = BottomBlobRight;

BottomBlobRight.default = BottomBlobRight;
